export default __webpack_public_path__ + "static/media/guber.c94af84a.svg";